import { Link } from "react-router-dom";
import "../style/home/H_Nav.css";

const H_Nav = () => {
  return (
    <div className="h-nav">
      <div className="h-nav-logo">
        آزما | <span style={{ fontSize: 13 }}>پلتفرم جامع آزمون</span>
      </div>
      <div className="h-nav-menu">
        <Link className="h-nav-menu-item" to="/">
          صفحه اصلی
        </Link>
        <Link className="h-nav-menu-item" to="/">
          امکانات
        </Link>
        <Link className="h-nav-menu-item" to="/">
          فروشگاه
        </Link>
        <Link className="h-nav-menu-item" to="/">
          درباره ما
        </Link>
        <Link className="h-nav-menu-item" to="/contact_us">
          تماس با ما
        </Link>
      </div>
      <div className="h-nav-login-box">
        {/* <div className="h-nav-login-box-text">تازه وارد هستید؟</div> */}
        <Link to="/login" className="h-nav-login-box-btn">
          ورود به حساب کاربری
        </Link>
      </div>
    </div>
  );
};

export default H_Nav;
